export default "__VITE_ASSET__BQYE5idm__";